<template>
  <div class="billing">
    <b-card class="animated fadeIn">
      <h1 class="mb-5">Billing</h1>

      <PaymentMethods class="mb-5" />

      <h3 v-if="!subscriptions.length" class="mb-5">
        No subscriptions.
        <b-link :to="{ name: 'Add License' }">Add license</b-link>
      </h3>
      <BillingSubscriptions v-else :items="subscriptions" class="mb-5" />

      <h3 v-if="!invoices.length">No invoices.</h3>
      <BillingInvoices v-else :items="invoices" />
    </b-card>
  </div>
</template>

<script>
import { mapState } from "vuex";

import BillingSubscriptions from "@/components/billing/BillingSubscriptions";
import BillingInvoices from "@/components/billing/BillingInvoices";
import PaymentMethods from "@/components/billing/PaymentMethods";

export default {
  components: {
    BillingSubscriptions,
    BillingInvoices,
    PaymentMethods
  },

  metaInfo: {
    titleTemplate: "Billing - %s"
  },

  computed: {
    ...mapState({
      subscriptions: state => {
        return state.billing.subscriptions.map(item => {
          const subscription = {
            ...item.plan,
            id: item.id,
            planId: item.plan.id,
            quantity: item.quantity,
            discount: item.discount
          };
          return subscription;
        });
      },

      invoices: state => {
        const invoices = state.billing.invoices.map(item => {
          const invoice = {
            ...item,
            datetime: new Date(item.date).getTime()
          };

          if (invoice.paid && invoice.closed) {
            invoice.status = "paid";
          } else if (!invoice.paid && invoice.closed) {
            invoice.status = "forgiven";
          } else {
            invoice.status = invoice.status.toLowerCase();
          }

          return invoice;
        });

        const { nextInvoice } = state.billing;
        if (nextInvoice) {
          invoices.unshift({
            ...nextInvoice,
            datetime: new Date(nextInvoice.date).getTime(),
            status: "upcoming"
          });
        }

        return invoices;
      }
    })
  },

  async created() {
    await Promise.all([
      this.$store.dispatch("billing/methods"),
      this.$store.dispatch("billing/subscriptions"),
      this.$store.dispatch("billing/invoices"),
      this.$store.dispatch("billing/nextInvoice")
    ]);
  }
};
</script>
